module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('option-config', {
    attrs: {
      "curInput": _vm.curInput,
      "selectConfig": _vm.curInput.select_option
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fee6a08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/selectConfig.vue
// module id = 1913
// module chunks = 2